import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Router } from "@reach/router";
import classNames from "classnames";
import { makeStyles } from "@material-ui/styles";
import Header from "./Common/Header";
import Nav from "./Common/nav";
import Member from "./registration/registermember";
import Ticket from "./registration/registerticket";
import SetPassword from "./password/set";
import RequestPassword from "./password/request";
import Registration from "./registration";
import Callback from "./infrastructure/callback";
import Account from "./account/index";
import Menu from "./Common/menu";
import OldBrowser from "./Common/oldBrowser";
import Toast from "./Common/toast";
import useLocation from "./Common/useLocation";

const useStyles = makeStyles((theme) => ({
  main: { height: `${theme.height - 1}px`, overflow: "hidden" },
  content: {
    background: theme.app.background[0],
    height: `${theme.height - 128}px`,
    overflow: "auto",
  },
  workSpace: {
    background: theme.app.background[0],
    height: `${theme.height - 128}px`,
    overflow: "auto",
    color: theme.app.color,
    "& h1": theme.typography.h1,
    "& h2": theme.typography.h2,
    "& h3": theme.typography.h3,
    "& h4": theme.typography.h4,
    "& h5": theme.typography.h5,
    "& h6": theme.typography.h6,
  },
  mainWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
  },
  footer: {
    margin: "0 auto",
    "& a": {
      fontSize: "0.9rem",
      color: theme.app.labelColor,
    },
  },
}));

const Workspace = ({ classes, hasNav }) => {
  const language = useSelector((state) => state.language);
  return (
    <>
      <Nav />
      <div className={classNames(classes.workSpace, "workspace__container")}>
        <Menu />
        <div className={classes.mainWrapper}>
          <main id="main-page-content-logged-out">
            <Router primary={false}>
              <Member path="/registermember" hasNav={hasNav} />
              <Ticket path="registerticket" hasNav={hasNav} />
              <SetPassword path="/setpassword/:id" />
              <RequestPassword path="/requestpassword" hasNav={hasNav} />
              <Registration path="/" />
            </Router>
          </main>
          <footer className={classes.footer}>
            <a href="https://sirius.entryevent.se/ee-static/members/tillganglighetsredogorelse.html">
              {language.AccessibilityStatement}
            </a>
          </footer>
        </div>
      </div>
    </>
  );
};

const Routes = (props) => {
  const { userManager } = props;
  const { language, auth, config } = useSelector((state) => ({
    auth: state.oidc.user !== null && !state.oidc.user.expired,
    config: state.infrastructure.config,
    language: state.language,
  }));
  const classes = useStyles();
  const ref = useRef(null);
  const { location } = useLocation();

  useEffect(() => {
    if (language && language.MyPages && config?.selfName) {
      window.document.title = `${language.MyPages} - ${config?.selfName}`;
    } else if (language && language.MyPages && !config?.selfName) {
      window.document.title = `${language.MyPages}`;
    }
  }, [config, language]);

  useEffect(() => {
    ref.current.focus();
  }, [location.pathname]);

  return (
    <div className={classNames(classes.main, "main-container")}>
      <div tabIndex={0} ref={ref} />
      {auth ? (
        <a href="#main-page-content-logged-in" className="main-content-link">
          {language.SkipToMainContent}
        </a>
      ) : (
        <a href="#main-page-content-logged-out" className="main-content-link">
          {language.SkipToMainContent}
        </a>
      )}

      <Header userManager={userManager} />
      <Router basepath={process.env.PUBLIC_URL}>
        <OldBrowser path="/oldbrowser" />
        <Callback path="/callback" userManager={userManager} />
        <Callback path="/members/callback" userManager={userManager} />
        {auth ? (
          <Account path="/*" userManager={userManager} />
        ) : (
          <Workspace
            path="/*"
            config={config}
            language={language}
            hasNav={!auth}
            classes={classes}
          />
        )}
      </Router>
      <Toast />
    </div>
  );
};

export default Routes;
